<template lang="pug">
.zoo-card
  img(src="~assets/icons/exps/zoo.jpg")
</template>
<script>
export default {
  name: 'ForestCard',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.zoo-card
  width: 100%
  height: 100%
  img
    width: 100%
    height: 100%
    object-fit: cover
</style>
